import { render, staticRenderFns } from "./PreOrderGeneralInfo.vue?vue&type=template&id=1908e24b&scoped=true&"
import script from "./PreOrderGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PreOrderGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderGeneralInfo.vue?vue&type=style&index=0&id=1908e24b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908e24b",
  null
  
)

export default component.exports